import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query, SortableQuery, encodeSortableQuery } from '../../request';

export interface UserQuery extends PaginatableQuery, SortableQuery {
  search: string;
  group: number[];
  entityItem: number[];
  role: number[];
}

export interface FilterUserQuery {
  includeDeleted?: boolean;
  permission?: string[];
}

export const defaultUserQuery: UserQuery = {
  page: 1,
  perPage: 1000,
  search: '',
  group: [],
  role: [],
  entityItem: [],
  sort: 'createdAt',
  dir: 'desc',
};

export const encodeUserQuery = (query: UserQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  search: q.string(query.search),
  group: q.numbers(query.group),
  entityItem: q.numbers(query.entityItem),
  role: q.numbers(query.role),
});

export const encodeFilterUserQuery = (query: FilterUserQuery): Query => ({
  permission: q.strings(query.permission || []),
  includeDeleted: query.includeDeleted ? '1' : '0',
});
